/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const ko_pollwidget_deleteoption2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`옵션 삭제`)
};

const en_pollwidget_deleteoption2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete option`)
};

const ja_pollwidget_deleteoption2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オプションを削除`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "ko" | "en" | "ja" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
const pollwidget_deleteoption2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pollwidget_deleteoption2(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("pollwidget_deleteoption2", locale)
	if (locale === "ko") return ko_pollwidget_deleteoption2(inputs)
	if (locale === "en") return en_pollwidget_deleteoption2(inputs)
	return ja_pollwidget_deleteoption2(inputs)
};
export { pollwidget_deleteoption2 as "pollWidget_deleteOption" }